import { ProjectPlan } from '../types';

// Mock data for SkySweets Donuts Project
export const mockProjectPlan: ProjectPlan = {
  projectId: 1,
  projectName: 'SkySweets Donuts Remodel',
  projectStartDate: '2024-01-15',
  phases: [
    {
      phaseId: 1,
      name: 'Phase 1: Design & Permitting',
      description: 'Complete design work and obtain necessary permits',
      startDate: '2024-01-15',
      endDate: '2024-02-15',
      duration: 0, // Will be calculated
      displayOrder: 1,
      tasks: [
        {
          taskId: 1,
          name: 'Create Floorplan',
          description: 'Design the new store layout',
          assignedUsers: ['architect@skysweets.com'],
          startDate: '2024-01-15',
          endDate: '2024-01-23',
          duration: 0, // Will be calculated
          prerequisites: [],
          parallelExecution: false,
          displayOrder: 1,
          actions: [
            {
              actionId: 1,
              actionType: 'CREATE',
              duration: 8,
              assignedTo: ['architect@skysweets.com'],
              notes: 'Draft initial floorplan',
              displayOrder: 1,
            },
            {
              actionId: 2,
              actionType: 'REVIEW',
              duration: 2,
              assignedTo: ['manager@skysweets.com'],
              notes: 'Review with Store Manager',
              displayOrder: 2,
            },
            {
              actionId: 3,
              actionType: 'REVISE',
              duration: 4,
              assignedTo: ['architect@skysweets.com'],
              notes: 'Revise based on feedback',
              displayOrder: 3,
            },
          ],
        },
        {
          taskId: 2,
          name: 'Health Dept Review',
          description: 'Submit plans for health department approval',
          assignedUsers: ['permit-coordinator@skysweets.com'],
          startDate: '2024-01-24',
          endDate: '2024-02-15',
          duration: 0, // Will be calculated
          prerequisites: [1],
          parallelExecution: false,
          displayOrder: 2,
          actions: [
            {
              actionId: 4,
              actionType: 'CREATE',
              duration: 1,
              assignedTo: ['permit-coordinator@skysweets.com'],
              notes: 'Submit plans to health department',
              displayOrder: 1,
            },
            {
              actionId: 5,
              actionType: 'APPROVE',
              duration: 240, // 10 days * 24 hours (waiting period)
              assignedTo: ['health-dept@city.gov'],
              notes: 'Waiting period: 10 days',
              displayOrder: 2,
            },
          ],
        },
        {
          taskId: 3,
          name: 'Building Permit Application',
          description: 'Apply for building permits with city',
          assignedUsers: ['permit-coordinator@skysweets.com'],
          startDate: '2024-01-20',
          endDate: '2024-02-10',
          duration: 0, // Will be calculated
          prerequisites: [],
          parallelExecution: false,
          displayOrder: 3,
          actions: [
            {
              actionId: 6,
              actionType: 'CREATE',
              duration: 4,
              assignedTo: ['permit-coordinator@skysweets.com'],
              notes: 'Prepare permit application documents',
              displayOrder: 1,
            },
            {
              actionId: 7,
              actionType: 'REVIEW',
              duration: 2,
              assignedTo: ['legal@skysweets.com'],
              notes: 'Legal review of application',
              displayOrder: 2,
            },
            {
              actionId: 8,
              actionType: 'APPROVE',
              duration: 336, // 14 days * 24 hours
              assignedTo: ['city-permits@city.gov'],
              notes: 'City review and approval period',
              displayOrder: 3,
            },
          ],
        },
      ],
    },
    {
      phaseId: 2,
      name: 'Phase 2: Construction',
      description: 'Execute construction and installation work',
      startDate: '2024-02-16',
      endDate: '2024-03-20',
      duration: 0, // Will be calculated
      displayOrder: 2,
      tasks: [
        {
          taskId: 4,
          name: 'Demolition Work',
          description: 'Remove existing fixtures and equipment',
          assignedUsers: ['contractor@skysweets.com'],
          startDate: '2024-02-16',
          endDate: '2024-02-20',
          duration: 0, // Will be calculated
          prerequisites: [],
          parallelExecution: false,
          displayOrder: 1,
          actions: [
            {
              actionId: 9,
              actionType: 'CREATE',
              duration: 16,
              assignedTo: ['contractor@skysweets.com'],
              notes: 'Remove old equipment and fixtures',
              displayOrder: 1,
            },
            {
              actionId: 10,
              actionType: 'REVIEW',
              duration: 2,
              assignedTo: ['manager@skysweets.com'],
              notes: 'Inspect demolition completion',
              displayOrder: 2,
            },
          ],
        },
        {
          taskId: 5,
          name: 'Install Equipment',
          description: 'Install new equipment and fixtures',
          assignedUsers: ['contractor@skysweets.com'],
          startDate: '2024-02-21',
          endDate: '2024-03-05',
          duration: 0, // Will be calculated
          prerequisites: [4],
          parallelExecution: false,
          displayOrder: 2,
          actions: [
            {
              actionId: 11,
              actionType: 'CREATE',
              duration: 24,
              assignedTo: ['contractor@skysweets.com'],
              notes: 'Install donut making equipment',
              displayOrder: 1,
            },
            {
              actionId: 12,
              actionType: 'CREATE',
              duration: 16,
              assignedTo: ['contractor@skysweets.com'],
              notes: 'Install display cases and fixtures',
              displayOrder: 2,
            },
            {
              actionId: 13,
              actionType: 'REVIEW',
              duration: 4,
              assignedTo: ['manager@skysweets.com', 'equipment-vendor@skysweets.com'],
              notes: 'Quality inspection of installations',
              displayOrder: 3,
            },
          ],
        },
        {
          taskId: 6,
          name: 'Electrical & Plumbing',
          description: 'Complete electrical and plumbing work',
          assignedUsers: ['electrician@skysweets.com', 'plumber@skysweets.com'],
          startDate: '2024-02-21',
          endDate: '2024-03-10',
          duration: 0, // Will be calculated
          prerequisites: [4],
          parallelExecution: false,
          displayOrder: 3,
          actions: [
            {
              actionId: 14,
              actionType: 'CREATE',
              duration: 20,
              assignedTo: ['electrician@skysweets.com'],
              notes: 'Install electrical systems',
              displayOrder: 1,
            },
            {
              actionId: 15,
              actionType: 'CREATE',
              duration: 16,
              assignedTo: ['plumber@skysweets.com'],
              notes: 'Install plumbing systems',
              displayOrder: 2,
            },
            {
              actionId: 16,
              actionType: 'REVIEW',
              duration: 4,
              assignedTo: ['inspector@city.gov'],
              notes: 'City inspection of electrical and plumbing',
              displayOrder: 3,
            },
          ],
        },
        {
          taskId: 7,
          name: 'Interior Finishing',
          description: 'Complete interior painting and finishing work',
          assignedUsers: ['contractor@skysweets.com'],
          startDate: '2024-03-06',
          endDate: '2024-03-20',
          duration: 0, // Will be calculated
          prerequisites: [5, 6],
          parallelExecution: false,
          displayOrder: 4,
          actions: [
            {
              actionId: 17,
              actionType: 'CREATE',
              duration: 12,
              assignedTo: ['painter@skysweets.com'],
              notes: 'Paint interior walls',
              displayOrder: 1,
            },
            {
              actionId: 18,
              actionType: 'CREATE',
              duration: 8,
              assignedTo: ['contractor@skysweets.com'],
              notes: 'Install flooring',
              displayOrder: 2,
            },
            {
              actionId: 19,
              actionType: 'REVIEW',
              duration: 2,
              assignedTo: ['manager@skysweets.com'],
              notes: 'Final walkthrough of interior',
              displayOrder: 3,
            },
          ],
        },
      ],
    },
    {
      phaseId: 3,
      name: 'Phase 3: Equipment & Inventory Setup',
      description: 'Set up equipment, inventory systems, and POS',
      startDate: '2024-03-21',
      endDate: '2024-04-10',
      duration: 0, // Will be calculated
      displayOrder: 3,
      tasks: [
        {
          taskId: 8,
          name: 'Equipment Calibration',
          description: 'Calibrate and test all equipment',
          assignedUsers: ['equipment-vendor@skysweets.com'],
          startDate: '2024-03-21',
          endDate: '2024-03-28',
          duration: 0, // Will be calculated
          prerequisites: [],
          parallelExecution: false,
          displayOrder: 1,
          actions: [
            {
              actionId: 20,
              actionType: 'CREATE',
              duration: 12,
              assignedTo: ['equipment-vendor@skysweets.com'],
              notes: 'Calibrate donut making equipment',
              displayOrder: 1,
            },
            {
              actionId: 21,
              actionType: 'REVIEW',
              duration: 4,
              assignedTo: ['manager@skysweets.com'],
              notes: 'Test equipment functionality',
              displayOrder: 2,
            },
            {
              actionId: 22,
              actionType: 'APPROVE',
              duration: 2,
              assignedTo: ['manager@skysweets.com'],
              notes: 'Approve equipment calibration',
              displayOrder: 3,
            },
          ],
        },
        {
          taskId: 9,
          name: 'POS System Setup',
          description: 'Install and configure point of sale system',
          assignedUsers: ['it@skysweets.com'],
          startDate: '2024-03-21',
          endDate: '2024-04-02',
          duration: 0, // Will be calculated
          prerequisites: [],
          parallelExecution: false,
          displayOrder: 2,
          actions: [
            {
              actionId: 23,
              actionType: 'CREATE',
              duration: 8,
              assignedTo: ['it@skysweets.com'],
              notes: 'Install POS hardware',
              displayOrder: 1,
            },
            {
              actionId: 24,
              actionType: 'CREATE',
              duration: 12,
              assignedTo: ['it@skysweets.com'],
              notes: 'Configure POS software and menu',
              displayOrder: 2,
            },
            {
              actionId: 25,
              actionType: 'REVIEW',
              duration: 4,
              assignedTo: ['manager@skysweets.com'],
              notes: 'Test POS system functionality',
              displayOrder: 3,
            },
          ],
        },
        {
          taskId: 10,
          name: 'Inventory System Setup',
          description: 'Set up inventory management system',
          assignedUsers: ['manager@skysweets.com'],
          startDate: '2024-03-29',
          endDate: '2024-04-10',
          duration: 0, // Will be calculated
          prerequisites: [8],
          parallelExecution: false,
          displayOrder: 3,
          actions: [
            {
              actionId: 26,
              actionType: 'CREATE',
              duration: 6,
              assignedTo: ['manager@skysweets.com'],
              notes: 'Configure inventory tracking system',
              displayOrder: 1,
            },
            {
              actionId: 27,
              actionType: 'CREATE',
              duration: 8,
              assignedTo: ['manager@skysweets.com'],
              notes: 'Set up initial inventory levels',
              displayOrder: 2,
            },
            {
              actionId: 28,
              actionType: 'REVIEW',
              duration: 2,
              assignedTo: ['operations@skysweets.com'],
              notes: 'Review inventory setup',
              displayOrder: 3,
            },
          ],
        },
      ],
    },
    {
      phaseId: 4,
      name: 'Phase 4: Staff Training & Opening',
      description: 'Train staff and prepare for grand opening',
      startDate: '2024-04-11',
      endDate: '2024-04-30',
      duration: 0, // Will be calculated
      displayOrder: 4,
      tasks: [
        {
          taskId: 11,
          name: 'Staff Hiring',
          description: 'Hire and onboard new staff members',
          assignedUsers: ['hr@skysweets.com'],
          startDate: '2024-04-11',
          endDate: '2024-04-20',
          duration: 0, // Will be calculated
          prerequisites: [],
          parallelExecution: false,
          displayOrder: 1,
          actions: [
            {
              actionId: 29,
              actionType: 'CREATE',
              duration: 8,
              assignedTo: ['hr@skysweets.com'],
              notes: 'Conduct interviews',
              displayOrder: 1,
            },
            {
              actionId: 30,
              actionType: 'REVIEW',
              duration: 4,
              assignedTo: ['manager@skysweets.com'],
              notes: 'Review candidate applications',
              displayOrder: 2,
            },
            {
              actionId: 31,
              actionType: 'APPROVE',
              duration: 2,
              assignedTo: ['manager@skysweets.com'],
              notes: 'Approve final hires',
              displayOrder: 3,
            },
            {
              actionId: 32,
              actionType: 'CREATE',
              duration: 4,
              assignedTo: ['hr@skysweets.com'],
              notes: 'Complete onboarding paperwork',
              displayOrder: 4,
            },
          ],
        },
        {
          taskId: 12,
          name: 'Equipment Training',
          description: 'Train staff on equipment operation',
          assignedUsers: ['equipment-vendor@skysweets.com', 'manager@skysweets.com'],
          startDate: '2024-04-21',
          endDate: '2024-04-25',
          duration: 0, // Will be calculated
          prerequisites: [11],
          parallelExecution: false,
          displayOrder: 2,
          actions: [
            {
              actionId: 33,
              actionType: 'CREATE',
              duration: 8,
              assignedTo: ['equipment-vendor@skysweets.com'],
              notes: 'Train staff on donut making equipment',
              displayOrder: 1,
            },
            {
              actionId: 34,
              actionType: 'REVIEW',
              duration: 4,
              assignedTo: ['manager@skysweets.com'],
              notes: 'Assess staff competency',
              displayOrder: 2,
            },
          ],
        },
        {
          taskId: 13,
          name: 'POS & Operations Training',
          description: 'Train staff on POS system and operations',
          assignedUsers: ['it@skysweets.com', 'manager@skysweets.com'],
          startDate: '2024-04-21',
          endDate: '2024-04-27',
          duration: 0, // Will be calculated
          prerequisites: [11],
          parallelExecution: false,
          displayOrder: 3,
          actions: [
            {
              actionId: 35,
              actionType: 'CREATE',
              duration: 6,
              assignedTo: ['it@skysweets.com'],
              notes: 'Train staff on POS system',
              displayOrder: 1,
            },
            {
              actionId: 36,
              actionType: 'CREATE',
              duration: 8,
              assignedTo: ['manager@skysweets.com'],
              notes: 'Train on store operations and procedures',
              displayOrder: 2,
            },
            {
              actionId: 37,
              actionType: 'REVIEW',
              duration: 2,
              assignedTo: ['manager@skysweets.com'],
              notes: 'Review training completion',
              displayOrder: 3,
            },
          ],
        },
        {
          taskId: 14,
          name: 'Soft Opening',
          description: 'Conduct soft opening with limited hours',
          assignedUsers: ['manager@skysweets.com'],
          startDate: '2024-04-28',
          endDate: '2024-04-30',
          duration: 0, // Will be calculated
          prerequisites: [12, 13],
          parallelExecution: false,
          displayOrder: 4,
          actions: [
            {
              actionId: 38,
              actionType: 'CREATE',
              duration: 8,
              assignedTo: ['manager@skysweets.com'],
              notes: 'Prepare for soft opening',
              displayOrder: 1,
            },
            {
              actionId: 39,
              actionType: 'REVIEW',
              duration: 16,
              assignedTo: ['manager@skysweets.com'],
              notes: 'Conduct soft opening operations',
              displayOrder: 2,
            },
            {
              actionId: 40,
              actionType: 'REVISE',
              duration: 4,
              assignedTo: ['manager@skysweets.com'],
              notes: 'Adjust procedures based on soft opening feedback',
              displayOrder: 3,
            },
          ],
        },
      ],
    },
  ],
};
